import AppHeader from "@/components/feature/AppHeader";
import AppFooter from "@/components/feature/AppFooter";
import AuthCard from "@/pages/auth/components/AuthCard";

const highlights = [
  { icon: "ri-key-2-line", title: "许可证集中管理", desc: "所有授权密钥、状态与到期时间一目了然。" },
  { icon: "ri-flow-chart", title: "进度实时跟踪", desc: "申请提交后随时查看待审批、已通过或已驳回。" },
  { icon: "ri-shield-check-line", title: "账号数据隔离", desc: "每个账号仅能看到属于自己的许可证与申请。" },
];

export default function AuthPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <AppHeader />

      <main className="flex-1">
        <section className="mx-auto grid w-full max-w-6xl gap-10 px-4 py-12 md:px-6 md:py-20 lg:grid-cols-2 lg:items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <span className="flex h-3 w-3 items-center justify-center">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              </span>
              授权账号中心
            </span>
            <h2 className="mt-4 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-4xl">
              一个账号，管理你的全部正版授权
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              登录后可自助申请授权、复制与激活许可证密钥、查看申请审批进度，让每一份授权都清晰可控。
            </p>

            <ul className="mt-8 flex flex-col gap-4">
              {highlights.map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{item.title}</p>
                    <p className="mt-0.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 h-44 w-full overflow-hidden rounded-lg md:h-52">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20green%20and%20amber%20geometric%20shapes%20softly%20layered%20on%20a%20clean%20light%20background%2C%20calm%20professional%20security%20theme%2C%20smooth%20gradients%2C%20editorial%20digital%20art%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=380&seq=auth-panel-2026&orientation=landscape"
                alt="授权账号中心插画"
                title="正版软件授权账号中心"
                className="h-full w-full object-top object-cover"
              />
            </div>
          </div>

          <div className="order-1 flex justify-center lg:order-2 lg:justify-end">
            <AuthCard />
          </div>
        </section>
      </main>

      <AppFooter />
    </div>
  );
}